<ng-container *ngIf="isTargetingVisible$ | async as isTargetingVisible">
  <div *ngIf="isTargetingVisible" class="form-group mb-4 pt-4">
    <h3 class="text-title-s-bold mb-2">Targeting</h3>
    <div class="d-flex flex-column targeting-control-container">
      <ng-content></ng-content>
    </div>
  </div>
</ng-container>
